import * as React from 'react';
import clx from 'classnames';
import './DossierTableCellActions.scss';
import { Link } from 'react-router-dom';
import { Button, Space, Tooltip } from 'antd';
import {
  ArrowRightOutlined,
  DownloadOutlined,
  EyeOutlined
} from '@ant-design/icons';
import { resolveApiPath } from 'client/core/appConfig';

export interface DossierTableCellActionsProps {
  to?: string;
  requestId: number | null;
  token: string;
  attachmentId?: number;
  isFolder?: boolean;
  isAttachment?: boolean;
  mobileOnly?: boolean;
}

/**
 * Cella finale della tabella documenti contenente le azioni (vai a | download)
 * TODO Inserire link corretti per pagina Documento e/o download
 */
export function DossierTableCellActions(props: DossierTableCellActionsProps) {
  if (props.isFolder) return null;
  if (!props.token) return null;
  if (!props.requestId) return null;

  const downloadLink = `/requests/${props.requestId}/document/${props.token}/`.concat(
    props.isAttachment
      ? `attachments/${props.attachmentId}/download`
      : `/download`
  );
  const textDownload = props.mobileOnly ? 'Download' : null;
  const textLink = props.mobileOnly ? (
    <>
      Vai <ArrowRightOutlined />
    </>
  ) : (
    <ArrowRightOutlined />
  );

  return (
    <Space
      direction="horizontal"
      size={0}
      className={clx('dossier-table-cell-actions', {
        'mobile-only': props.mobileOnly
      })}
    >
      <Tooltip
        title={`Download ${props.isAttachment ? 'Allegato' : 'Documento'}`}
      >
        <a href={resolveApiPath(downloadLink)} target="_blank">
          <Button
            type="link"
            size="large"
            icon={<DownloadOutlined />}
            children={textDownload}
          />
        </a>
      </Tooltip>

      {!props.isAttachment && props.to != null && (
        <Tooltip title="Dettaglio Documento">
          <Link to={props.to}>
            <Button type="link" size="large" children={textLink} />
          </Link>
        </Tooltip>
      )}
    </Space>
  );
}
